import { formatDate } from "@angular/common";
import { saveAs } from "file-saver";

export function saveAsZip(blobPart: BlobPart, filenamePrefix: string = "cb_replicator_logs_") {
  saveAsWithTimestamp(blobPart, filenamePrefix, "zip");
}

export function saveAsWithTimestamp(blobPart: BlobPart, filenamePrefix: string, filenameExtension: string ) {
  const data: Blob = new Blob([blobPart], { type: "application/octet-stream" });
  const formattedDate = formatDate(new Date(), "yyyyddMMHHmmss", "en-US");
  const filename = filenamePrefix + formattedDate + "." + filenameExtension;
  saveAs(data, filename);
}

export function saveAsExcel(blobPart: BlobPart, filenamePrefix: string = "cb_replicator_logs_") {
  const data: Blob = new Blob([blobPart], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
  const formattedDate = formatDate(new Date(), "yyyyddMMHHmmss", "en-US");
  const filename = filenamePrefix + formattedDate + ".xlsx";
  saveAs(data, filename);
}
